import React, { useState } from 'react'

import BatchesPanel from './BatchesPanel'
import { useJobCodingBatchesPaged } from '../../hooks/useCodingBatchesPaged'

/**
 * Every coding batch this JOB has sent to a model, whichever pipeline sent it.
 *
 * The observation this exists for is "a bunch of new batches just arrived",
 * which is a job-level statement: a connector tick can create batches across
 * several pipelines, and the pipeline-scoped table could only answer it if you
 * already knew which pipeline to open. So this is the screen you watch after
 * running an import.
 *
 * Same table, same rules, one column wider (Pipeline) — see BatchesPanel.
 */
export interface JobBatchesViewProps {
  customer: string
  job: string
  /** False while the view is hidden — a hidden view must not poll. */
  active?: boolean
}

const JobBatchesView: React.FC<JobBatchesViewProps> = ({ customer, job, active = true }) => {
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(25)

  const { data, loading, isFetching, error, refetch } = useJobCodingBatchesPaged(
    customer,
    job,
    page,
    rowsPerPage,
    active,
  )

  return (
    <BatchesPanel
      customer={customer}
      job={job}
      title="Coding batches"
      subtitle="Every batch this job has sent to a model, newest first, whichever pipeline sent it."
      emptyText="No coding batches for this job yet. Import some data, or send existing records to a pipeline, and the batches will appear here."
      showPipeline
      data={data}
      loading={loading}
      isFetching={isFetching}
      error={error}
      refetch={refetch}
      page={page}
      rowsPerPage={rowsPerPage}
      onPageChange={setPage}
      onRowsPerPageChange={setRowsPerPage}
    />
  )
}

export default JobBatchesView
